export default __webpack_public_path__ + "static/media/IMG_0285.d29f1029.jpeg";